import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationEN from './locales/en.json'
import translationMR from './locales/mr.json'
import translationHI from './locales/hi.json'
import translationZH from './locales/zh.json'

const resources = {
  en: {
    translation: translationEN,
  },
  mr: {
    translation: translationMR,
  },
  hi: {
    translation: translationHI,
  },
  zh: {
    translation: translationZH,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('preferredLanguage') || 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
